import { configureStore } from '@reduxjs/toolkit';
import authSlice from '../slices/authSlice';
import { portalSelectedSlice } from '../slices/portalSelectedSlice';


const store = configureStore({
    
    reducer: {
        auth: authSlice.reducer,
        portalSelected: portalSelectedSlice.reducer
    }
})

export default store;